module.exports = __webpack_public_path__ + "static/media/ConstituencyGrey.f683bbec.svg";